<script setup lang="ts">
    import { IntegrationProvider } from 'models'
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'

    const props = defineProps<{
        provider?: IntegrationProvider
    }>()

    const { t: $t, te: $te } = useI18n({
        useScope: 'global',
    })

    const label = computed(() => {
        return $te(`integrationProvider.${props.provider}`)
            ? $t(`integrationProvider.${props.provider}`)
            : props.provider
    })
    const icon = computed(() => {
        return `mdi:${props.provider}`
    })
</script>

<template>
    <div class="flex gap-sm items-center min-w-0">
        <span
            class="w-40 h-40 shrink-0 rounded-lg border border-surface-3 bg-surface-1 flex items-center justify-center text-18">
            <VvIcon :name="icon" :title="label" />
        </span>
        <span class="truncate">
            {{ label }}
        </span>
    </div>
</template>
